module.exports = __webpack_public_path__ + "img/bezirksblaetter.f18edca5.svg";